import { Injectable } from "@angular/core";
import { CookieService } from 'ngx-cookie-service';
import { ResponseModel } from "src/app/models/response.model";
import { LoginResponseModel } from "../models/login-response.model";
import { UserInfoModel } from "../models/user-info.model";
import { UserTokenModel } from "../models/user-token.model";
@Injectable()
export class LocalCookiesService {

    /**
     *
     */
    constructor(private cookieService: CookieService) {

    }
    criar(response: ResponseModel) {

        let loginResponse: LoginResponseModel;
        loginResponse = Object.assign({}, response.data, loginResponse)
        this.cookieService.set('Saber.EditorConteudos.AccessInfo', loginResponse.userToken.accessToken, loginResponse.userToken.expiresIn);
        this.cookieService.set('Saber.EditorConteudos.UserInfo', JSON.stringify(loginResponse.userInfo), loginResponse.userToken.expiresIn);
    }
    obterUserInfo(): UserInfoModel {

        let cookie = this.cookieService.get('Saber.EditorConteudos.UserInfo');
        if (!cookie) return null;
        let userInfo: UserInfoModel = <UserInfoModel>JSON.parse(cookie);
        return userInfo;
    }
    obterAccessToken() {
        const cookie = this.cookieService.get('Saber.EditorConteudos.AccessInfo');
        if (!cookie) return null;
        const userToken: UserTokenModel = new UserTokenModel();
        userToken.accessToken = cookie;
        return userToken.accessToken;

    }
    removerDados(): boolean {
        // let access = this.cookieService.check('Saber.EditorConteudos.AccessInfo');
        // if (access)
        //     this.cookieService.delete('Saber.EditorConteudos.AccessInfo');
        // let user = this.cookieService.check('Saber.EditorConteudos.UserInfo');
        // if (user)
        //     this.cookieService.delete('Saber.EditorConteudos.UserInfo');
        this.cookieService.deleteAll();
        let user = this.cookieService.check('Saber.EditorConteudos.UserInfo');
        let access = this.cookieService.check('Saber.EditorConteudos.AccessInfo');

        if (!user && !access)
            return true
        return false

    }
}
